import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ModalHeader from 'react-bootstrap/esm/ModalHeader';
// import { ModalBody, ModalFooter } from 'react-bootstrap';


//  export   const ModalHeader = props => {
//     return <div className="modal-header" style={{backgroundColor:'white',textAlign:' center',verticalAlign: 'middle'}}>{props.children}</div>;
// };

//  export const ModalBody = props => {
//     return <div className="modal-body">{props.children}</div>;
// };

//  export const ModalFooter = props => {
//     return <div className="modal-footer">{props.children}</div>;
// };

export default class ModalHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow: '',
            display: 'none'
        }
    };
    render() {
        return (
            // <div className="modal-header" style={{backgroundColor:'white',textAlign:' center',verticalAlign: 'middle'}}>
            <div className={this.props.HeaderStyle} style={{ backgroundColor: 'white', textAlign: ' center', verticalAlign: 'middle' }}>
                {this.props.children}
            </div>
        )
    }

}



